import { ApiEpOrganization } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.organization.membership";

export const useQueryOrganizationMembershipList = (
  params?: Parameters<typeof ApiEpOrganization.Membership.list>[0],
  options?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpOrganization.Membership.list>>
    >,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<Await<ReturnType<typeof ApiEpOrganization.Membership.list>>>(
    [KEY, params],
    () => ApiEpOrganization.Membership.list(params || {}),
    options,
  );

useQueryOrganizationMembershipList.KEY = KEY;
